import React, { PureComponent } from "react";
import moment from "moment";
import "./style.css";
import {
  Dialog,
  DialogType,
  DialogContent,
  DatePicker,
  DialogFooter,
  Spinner,
  SpinnerSize,
  PrimaryButton,
  DefaultButton,
} from "office-ui-fabric-react";

class MoveToWaitModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    };

    this.handleSubmitForm = this.handleSubmitForm.bind(this);
  }

  handleSubmitForm() {
    this.setState(
      {
        loading: true,
      },
      async () => {
        const isDone = await this.props.submitForm();
        if (isDone) {
          this.setState({
            loading: false,
          });
          this.props.onClose();
        }
      }
    );
  }

  render() {
    const { isOpen, inputs, updateInputs, onClose } = this.props;
    const { loading } = this.state;
    
    return (
      <Dialog
        isOpen={isOpen}
        type={DialogType.normal}
        onDismiss={onClose}
        title="Move to Wait List"
        isBlocking
        containerClassName="modal-move-to-wait"
      >
        <DialogContent>
          <div className="ms-Grid">
            <div className="one-line-150">
              <DatePicker
                label="Reminder date"
                formatDate={(date) => moment(date).format("MMM DD YYYY")}
                value={inputs.reminderDate && new Date(inputs.reminderDate) ||  new Date()}
                onSelectDate={(date) => updateInputs({ reminderDate: date })}
              />
            </div>
          </div>
        </DialogContent>
        <DialogFooter>
          {loading ? (
            <Spinner key="moveToWaitLoadingIcon" size={SpinnerSize.large} />
          ) : (
            [
              <PrimaryButton key="submitButton" onClick={this.handleSubmitForm}>
                {"Save"}
              </PrimaryButton>,
              <DefaultButton key="cancelButton" onClick={onClose}>
                {"Cancel"}
              </DefaultButton>,
            ]
          )}
        </DialogFooter>
      </Dialog>
    );
  }
}

export default MoveToWaitModal;



// WEBPACK FOOTER //
// ./client/components/common/MoveToWaitModal/index.js